(() => {
  'use strict';
  const form=document.getElementById('eva-giveaway-form');
  if(!form)return;
  const messages=JSON.parse(document.getElementById('eva-giveaway-messages').textContent);
  const button=form.querySelector('button[type=submit]');
  const feedback=document.getElementById('eva-giveaway-feedback');
  const success=document.getElementById('eva-giveaway-success');
  const site=form.dataset.siteId;
  const locale=form.dataset.locale.toLowerCase().startsWith('nl')?'nl-NL':'en';
  const isPreview=Boolean(window.Shopify?.designMode||window.Shopify?.previewMode);
  let busy=false;
  const timeState=()=>Date.now()<Date.parse(form.dataset.open)?'not_open':Date.now()>=Date.parse(form.dataset.close)?'closed':null;
  const updateAvailability=()=>{const state=timeState();button.disabled=busy||Boolean(state);if(state)feedback.textContent=messages[state];else if([messages.not_open,messages.closed].includes(feedback.textContent))feedback.textContent=''};
  updateAvailability();
  // Periodic check ensures an already-open browser stops accepting entries at the closing time.
  setInterval(()=>{if(!busy&&!form.hidden)updateAvailability()},30000);
  const post=async(endpoint,payload)=>{
    const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),15000);
    try{const response=await fetch('https://a.klaviyo.com/client/'+endpoint+'/?company_id='+encodeURIComponent(site),{method:'POST',headers:{accept:'application/vnd.api+json','content-type':'application/vnd.api+json',revision:'2026-07-15'},body:JSON.stringify(payload),signal:controller.signal});if(!response.ok)throw Error('Submission failed');return response.status}finally{clearTimeout(timer)}
  };
  form.addEventListener('submit',async(event)=>{
    event.preventDefault();if(busy||!form.reportValidity())return;
    const state=timeState();if(state){feedback.textContent=messages[state];return}
    if(form.elements.website.value)return;
    if(isPreview){feedback.textContent=messages.preview;return}
    busy=true;button.disabled=true;button.textContent=messages.busy;feedback.textContent='';
    const properties={eva_winactie_2026:true,eva_winactie_source:'landing_2026',eva_winactie_terms_version:'2026-10-08',eva_bf_language:locale==='nl-NL'?'nl':'en'};
    // Only campaign attribution is retained; no URL query strings or unrelated personal data.
    const params=new URLSearchParams(location.search);
    for(const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']){const value=params.get(key);if(value)properties['eva_winactie_'+key]=value.slice(0,200)}
    const attrs={email:form.elements.email.value.trim(),first_name:form.elements.first_name.value.trim(),locale,properties};
    let entrySaved=false;
    try{
      await post('profiles',{data:{type:'profile',attributes:attrs}});entrySaved=true;
      const wantsEmail=form.elements.marketing.checked;
      if(wantsEmail){
        await post('subscriptions',{
          data:{
            type:'subscription',
            attributes:{
              custom_source:'EVA Winactie 2026 landing '+locale,
              profile:{data:{type:'profile',attributes:{
                ...attrs,
                properties:{...properties,eva_bf_2026:true},
                subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}
              }}}
            },
            relationships:{list:{data:{type:'list',id:form.dataset.listId}}}
          }
        });
      }
      form.hidden=true;success.hidden=false;success.querySelector('p').textContent=messages[wantsEmail?'success_optin':'success'];success.focus();
      // No name or email is sent to analytics. Analytics events require the shop's analytics consent.
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'eva_giveaway_signup',campaign:'bf_2026',language:locale,early_access_requested:wantsEmail})}
    }catch(error){feedback.textContent=messages[entrySaved?'partial':'failure']}
    finally{busy=false;button.disabled=false;button.textContent=messages.enter}
  });
})();
